import { useQuery } from '@tanstack/react-query';

import programs from '@clients/programsClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getProgramParameters } = programs();
interface UseGetProgramParametersOptions {
    programId: number;
    onSuccess?: () => void;
    onError?: () => void;
    enabled?: boolean;
}
const useGetProgramParameters = ({
    programId,
    onSuccess,
    onError,
    enabled = true,
}: UseGetProgramParametersOptions) => {
    const { data, error, isError, isLoading, refetch } = useQuery(
        ['getProgramParameters', programId],
        () => getProgramParameters({ programId }),
        {
            onSuccess: onSuccess,
            onError: (error) => {
                notifyAPIError(error);
                onError?.();
            },
            enabled: !!programId && enabled,
        },
    );
    return { data, error, isError, isLoading, refetch };
};
export default useGetProgramParameters;
